import React from "react";
import { makeIconDef } from "./makeIconDef";
export var MoreIconDef = {
    more: makeIconDef('more', {
        regular: function () { return React.createElement(React.Fragment, null,
            React.createElement("rect", { x: "4", y: "10", width: "3", height: "3", rx: "1.5", fill: "currentColor" }),
            React.createElement("rect", { x: "10.5", y: "10", width: "3", height: "3", rx: "1.5", fill: "currentColor" }),
            React.createElement("rect", { x: "17", y: "10", width: "3", height: "3", rx: "1.5", fill: "currentColor" })); }
    })
};
